import { valueOrNA } from 'Common/valueOrNA';
import { formatMake } from 'utils/make';
import { toCapitalize } from 'Common/string';

export const getDerivativeDisplayName = derivative =>
  toCapitalize(
    `${formatMake(valueOrNA(derivative, 'make'))} ` +
      `${formatMake(valueOrNA(derivative, 'range'))} ` +
      `${valueOrNA(derivative, 'derivative')}` +
      `${derivative.name ? ' ' + derivative.name : ''}`
  );



// WEBPACK FOOTER //
// ./src/utils/derivative/index.js